<div class="min-h-screen xl:flex">
  <div>
    <!-- Menú lateral: oculto en escritorio cuando la disposición es 'topnav'.
         En pantallas estrechas (< xl) sigue actuando como cajón, sea cual sea la disposición. -->
    <app-sidebar-menu [ngClass]="{ 'xl:hidden': navLayout() === 'topnav' }"></app-sidebar-menu>
    <app-backdrop></app-backdrop>
  </div>
  <div
      class="flex-1 transition-all duration-300 ease-in-out"
      [ngClass]="{
        'xl:ml-[290px]': navLayout() === 'sidebar' && ((isExpanded$ | async) || (isHovered$ | async)),
        'xl:ml-[90px]': navLayout() === 'sidebar' && !((isExpanded$ | async) || (isHovered$ | async)),
        'xl:ml-0': navLayout() === 'topnav',
        'ml-0': (isMobileOpen$ | async)
      }"
  >
    <!-- app header start -->
    <app-header/>
    <!-- app header end -->

    <!-- Barra de navegación horizontal: solo en escritorio y solo en modo 'topnav' -->
    @if (navLayout() === 'topnav') {
      <app-top-nav class="hidden xl:block"></app-top-nav>
    }

    <div class="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
      <router-outlet></router-outlet>
      <app-modal-host></app-modal-host>
    </div>
  </div>
</div>
